import { render, staticRenderFns } from "./UserMescanMetabolismComparison.vue?vue&type=template&id=b8ea8624&scoped=true"
import script from "./UserMescanMetabolismComparison.vue?vue&type=script&lang=js"
export * from "./UserMescanMetabolismComparison.vue?vue&type=script&lang=js"
import style0 from "./UserMescanMetabolismComparison.vue?vue&type=style&index=0&id=b8ea8624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ea8624",
  null
  
)

export default component.exports